/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleExceptionTemplate
 */
export interface ScheduleExceptionTemplate {
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionTemplate
     */
    reason: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ScheduleExceptionTemplate
     */
    localEndTime: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ScheduleExceptionTemplate
     */
    localStartTime: string;
    /**
     * ISO8601 local date string , e.g. 2025-04-16
     * @type {string}
     * @memberof ScheduleExceptionTemplate
     */
    localDate: string;
}

/**
 * Check if a given object implements the ScheduleExceptionTemplate interface.
 */
export function instanceOfScheduleExceptionTemplate(value: object): value is ScheduleExceptionTemplate {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    return true;
}

export function ScheduleExceptionTemplateFromJSON(json: any): ScheduleExceptionTemplate {
    return ScheduleExceptionTemplateFromJSONTyped(json, false);
}

export function ScheduleExceptionTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleExceptionTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'localDate': json['localDate'],
    };
}

export function ScheduleExceptionTemplateToJSON(value?: ScheduleExceptionTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'localDate': value['localDate'],
    };
}

